import {ENTITY_CARD_DRAG_MIME} from './entityCardConstants';

function normalizeCountries(countries) {
    return [...new Set((countries || []).filter(Boolean))].slice(0, 10);
}

function normalizeRelatedCountryDetails(details, fallbackNames = []) {
    if (Array.isArray(details) && details.length > 0) {
        const deduped = new Map();
        for (const item of details) {
            const name = item?.name?.trim();
            if (!name) continue;
            const existing = deduped.get(name);
            const flagUrl = item?.flagUrl || existing?.flagUrl || '';
            deduped.set(name, {name, flagUrl});
        }
        return Array.from(deduped.values()).slice(0, 10);
    }

    return normalizeCountries(fallbackNames).map((name) => ({name, flagUrl: ''}));
}

export function serializeEntityCardDragPayload(entity) {
    return JSON.stringify({
        id: entity?.id || entity?.wikidataId || entity?.entityRef || '',
        label: entity?.label || entity?.canonicalName || entity?.name || '',
        description: entity?.description || '',
        imageUrl: entity?.imageUrl || entity?.image || '',
        relatedCountries: normalizeCountries(entity?.relatedCountries),
        relatedCountryDetails: normalizeRelatedCountryDetails(
            entity?.relatedCountryDetails,
            entity?.relatedCountries,
        ),
    });
}

/** Starts an HTML5 drag that the chart canvas accepts as a new entity card. */
export function writeEntityCardDragData(dataTransfer, entity) {
    if (!dataTransfer || !entity) {
        return false;
    }
    const payload = serializeEntityCardDragPayload(entity);
    let parsed;
    try {
        parsed = JSON.parse(payload);
    } catch {
        return false;
    }
    if (!parsed?.id) {
        return false;
    }
    dataTransfer.effectAllowed = 'copy';
    dataTransfer.setData(ENTITY_CARD_DRAG_MIME, payload);
    if (parsed.label) {
        dataTransfer.setData('text/plain', parsed.label);
    }
    return true;
}

export function parseEntityCardDragPayload(dataTransfer) {
    const raw = dataTransfer?.getData?.(ENTITY_CARD_DRAG_MIME);
    if (!raw) return null;

    try {
        const parsed = JSON.parse(raw);
        if (!parsed?.id) return null;
        return parsed;
    } catch {
        return null;
    }
}
